module.exports = __webpack_public_path__ + "4e5aa8ead3e644ca5171bf2c4d6662d4.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/leagues/brasil.png
// module id = 1044
// module chunks = 0